/** Welkomstmuziek na het inloggen: Vivaldi — De Vier Jaargetijden, "Lente" (publiek domein,
 *  opname van The Modena Chamber Orchestra via Musopen). Start enkel na een klik van de
 *  gebruiker, zoals browsers vereisen, en stopt zodra er een toets of de muis wordt gebruikt. */
let audio = null;
let detach = null;

function fadeOutAndStop() {
  if (!audio) return;
  const el = audio;
  const step = el.volume / 12;
  const timer = setInterval(() => {
    el.volume = Math.max(0, el.volume - step);
    if (el.volume <= 0.01) {
      clearInterval(timer);
      el.pause();
      el.currentTime = 0;
    }
  }, 50);
}

export function stopWelcome() {
  if (detach) { detach(); detach = null; }
  fadeOutAndStop();
}

export function playWelcome(enabled = true) {
  if (!enabled) return;
  if (!audio) {
    audio = new Audio("/audio/vivaldi-lente.mp3");
    audio.preload = "auto";
  }
  audio.volume = 0.5;
  audio.currentTime = 0;
  audio.play().catch(() => { /* geluid geweigerd door de browser is niet blokkerend */ });

  // Stoppen bij de eerste toetsaanslag of muisbeweging, met een korte marge voor de inlogklik
  if (detach) detach();
  const armAt = Date.now() + 400;
  const onAny = () => { if (Date.now() >= armAt) stopWelcome(); };
  const events = ["keydown", "mousemove", "mousedown", "wheel", "touchstart"];
  events.forEach((e) => window.addEventListener(e, onAny, { passive: true }));
  const onEnded = () => stopWelcome();
  audio.addEventListener("ended", onEnded);
  detach = () => {
    events.forEach((e) => window.removeEventListener(e, onAny));
    audio.removeEventListener("ended", onEnded);
  };
}
